import { OnboardingEntityDraft } from "v2/components/onboarding/OnboardingDataContext";
import { OnboardingEntityInput } from "v2/store/onboardingEntityApi";

export const toEntityInput = (
  draft: OnboardingEntityDraft,
  source?: string
): OnboardingEntityInput => ({
  formationTypeId: draft.formationTypeId,
  entityName: draft.entityName.trim(),
  entitySuffix: draft.entitySuffix,
  addressData: draft.addressData ?? undefined,
  taxedAs: draft.taxedAs,
  cStateId: draft.cStateId,
  dateOfIncorporation: draft.dateOfIncorporation,
  source,
});
